import { faGithub, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import SVGAnimationLogo from '../../uiParts/SVGAnimationLogo/SvgAnimationLogo';
import { FaPortalLinkIcon } from '../../uiParts/FaPortalLinkIcon/FaPortalLinkIcon';

import styles from './Header.module.css';

export default function Header() {
  return (
    <header className={styles.header}>
      <h1>
        <Link to="/">
          <SVGAnimationLogo />
        </Link>
      </h1>
      <div className={styles.flexRow}>
        <FaPortalLinkIcon
          faIcon={faGithub as IconDefinition}
          bgc="#000000"
          link="https://github.com/kvjnf/kvjnf-portfolio"
        />
        <FaPortalLinkIcon
          faIcon={faLinkedinIn as IconDefinition}
          bgc="#0073b1"
          link="https://www.linkedin.com/in/daisuke-akiyama-5b0222120"
        />
      </div>
    </header>
  );
}
